module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-config-service.789d4ce4.png";